import React from 'react'

function PlusIcon() {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="46" viewBox="0 0 23 46">
  <text id="_" data-name="+" transform="translate(0 38)" font-size="39" font-family="Lato-Regular, Lato"><tspan x="0" y="0">+</tspan></text>
</svg>

    </div>
  )
}

export default PlusIcon
